var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3008 1.57227L11.5284 8.3447C11.2816 8.59146 11.1582 8.71485 11.0159 8.76107C10.8908 8.80174 10.756 8.80174 10.6308 8.76107C10.4886 8.71485 10.3652 8.59146 10.1184 8.3447L7.78967 6.01595C7.5429 5.76918 7.41952 5.6458 7.27724 5.59957C7.1521 5.55891 7.01729 5.55891 6.89214 5.59957C6.74986 5.6458 6.62648 5.76918 6.37971 6.01595L0.853516 11.5421M18.3008 1.57227H13.3159M18.3008 1.57227V6.55721",
    stroke: "#4ABE51",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trend-up.08de4571d0dc795c537bc604ae2b0ff0.svg";
export { ForwardRef as ReactComponent };